import { FunctionComponent } from 'react';
import { NoValue } from '../../../sharedComponents/NoValue';
import { DateTime } from '../../../sharedComponents/table/BaseTableComponents';
import {
    Arrival,
    DepartedVehicle,
    ExpectedArrival,
    IncomingVehicle,
    InventoryVehicle,
} from '../../compoundManagement.types';
import { DisplayCancellableData } from './DisplayCancellableData';

type DisplayArrivalProps = {
    compoundVehicle: IncomingVehicle | InventoryVehicle | DepartedVehicle;
};

export const DisplayArrivalDate: FunctionComponent<{ compoundVehicle: InventoryVehicle | DepartedVehicle }> = ({
    compoundVehicle,
}) => {
    const hasArrival = compoundVehicle.arrival !== undefined;
    return hasArrival ? (
        <DisplayCancellableData isCancelled={compoundVehicle.arrival.isCancelled}>
            <DateTime
                dateTime={compoundVehicle.arrival.arrivalCompletedAt}
                timeZone={compoundVehicle.compoundLocation.timeZone}
            />
        </DisplayCancellableData>
    ) : (
        <NoValue />
    );
};

export const DisplayArrivalFreightForwarder = (props: { arrival: ExpectedArrival | Arrival | undefined }) => {
    const freightForwarder = props.arrival?.freightForwarder;
    return freightForwarder ? (
        <DisplayCancellableData isCancelled={props.arrival === undefined || props.arrival.isCancelled}>
            <span className="ellipsis-1">
                {freightForwarder.name} {freightForwarder.additionalName}
            </span>
        </DisplayCancellableData>
    ) : (
        <NoValue />
    );
};

export const DisplayArrivalFromLocationId: FunctionComponent<DisplayArrivalProps> = ({ compoundVehicle }) => {
    const arrivalFromLocationId = compoundVehicle.arrival?.arrivalFrom?.identifier;
    return arrivalFromLocationId ? (
        <DisplayCancellableData isCancelled={compoundVehicle.arrival.isCancelled}>
            {arrivalFromLocationId}
        </DisplayCancellableData>
    ) : (
        <NoValue />
    );
};

export const DisplayArrivalFromCity: FunctionComponent<DisplayArrivalProps> = ({ compoundVehicle }) => {
    const arrivalFromCity = compoundVehicle.arrival?.arrivalFrom?.address?.city;
    return arrivalFromCity ? (
        <DisplayCancellableData isCancelled={compoundVehicle.arrival.isCancelled}>
            {arrivalFromCity}
        </DisplayCancellableData>
    ) : (
        <NoValue />
    );
};
